/*
 * @Author: stevensh
 * @Date: 2020-02-28 10:58:58
 * @Last Modified by: stevensh
 * @Last Modified time: 2020-04-09 23:01:58
 */
import React from 'react';
import { Router, Switch } from 'react-router';
import { IntlProvider } from 'react-intl';
import { Provider } from 'mobx-react';
import { ConfigProvider } from 'antd';
import { AppProvider } from '@shopify/polaris';
import history from 'utils/history';
import zh_CN_App from './i18n-locales/zh_CN'; // import defined messages in Chinese
import en_US_App from './i18n-locales/en_US';
import enUS from 'antd/es/locale/en_US';
import zhCN from 'antd/es/locale/zh_CN';
import { getStorage, setStorage } from './utils/storage';
import { Route } from 'components';
import Frame from 'view/Frame';

import { TrackListPages } from 'modules/track-list/track-list.page';
import FAQ from 'modules/track-faq/track-faq.page';
import TrackVideo from 'modules/track-video/track-video.page';

const enTranslations = require('@shopify/polaris/locales/en.json');

var lang = navigator.language;

const appTitle = 'shopify-app';

declare global {
  interface Window {
    _spGame: any;
    FB: any;
    confirmOptIn: any;
  }
}
export default (store: {}): JSX.Element => {
  const locale = getStorage('locale') ? getStorage('locale') : 'zh';
  if (!getStorage('locale')) {
    setStorage('locale', 'zh');
  }
  let messages = {};
  messages['en'] = en_US_App;
  messages['zh'] = zh_CN_App;

  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      <ConfigProvider locale={locale === 'zh' ? zhCN : enUS}>
        <AppProvider i18n={enTranslations}>
          <Provider {...store}>
            {/*  TODO history需要优化   */}
            <Router history={history.getAppHistory()}>
              <Switch>
                <Route
                  exact
                  path="/"
                  parent={Frame}
                  component={TrackListPages}
                  title={`${appTitle}-${
                    getStorage('locale') === 'en' ? '列表' : 'list'
                  }`}
                />
                <Route path="/track-faq" parent={Frame} component={FAQ}></Route>
                <Route
                  path="/track-list"
                  parent={Frame}
                  component={TrackListPages}
                  title={`${appTitle}-${
                    getStorage('locale') === 'en' ? '列表' : 'list'
                  }`}
                ></Route>
                <Route
                  path="/track-video"
                  parent={Frame}
                  component={TrackVideo}
                  title={`${appTitle}-${
                    getStorage('locale') === 'en' ? '列表' : 'list'
                  }`}
                ></Route>
              </Switch>
            </Router>
          </Provider>
        </AppProvider>
      </ConfigProvider>
    </IntlProvider>
  );
};
